/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  dummy: 'dummy_c0074f18',
};

export = styles;

loadStyles([{"rawString":".dummy_c0074f18{background:#00f}"}]);
/* tslint:enable */